<template>
  <div>
    <div class="ban_main">
      <div class="ban_slide slick">
        <div class="ban_list">
          <figure>
            <!-- eslint-disable-next-line vue/html-self-closing -->
            <img src="/images/banner.png" width="1400" height="720" alt="banner" />
          </figure>
          <div class="banner_cnt">
            <div class="care d-flex flex-wrap">
              <div class="care_left col-md-6">
                <h1>TrueLifeCare</h1>
                <p>
                  “Where there is no guidance, a people falls, but in
                  an abundance of counselors there is safety.”
                  ~ Proverbs 11:14
                </p>

                <a
                  href="javascript:void(0)"
                  data-toggle="modal"
                  data-target=".video-modal"
                >Pastor Intro Video</a>
              </div>
              <div class="care_rgt col-md-6">
                <div class="sign">
                  <div class="sign_in">
                    <div class="sign_hd">
                      <h2>Sign In</h2>
                    </div>
                    <div class="sign_form">
                      <ul>
                        <li>
                          <!-- eslint-disable-next-line vue/html-self-closing -->
                          <input id="loginUserName" type="text" placeholder="Username or Email" />
                        </li>
                        <li>
                          <!-- eslint-disable-next-line vue/html-self-closing -->
                          <input id="loginPassword" type="password" placeholder="Password" />
                        </li>
                        <li>
                          <button type="submit" @click.prevent="handleSubmit">Login</button>
                        </li>
                        <li>
                          <a href="javascript:void(0)">Forgot Password?</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="clearfix" />
                </div>
              </div>
              <div class="clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_content">
      <div class="association_main">
        <div class="container">
          <div class="association">
            <div class="counselors">
              <figure>
                <img src="/images/img2.png" alt="img2" />
              </figure>
              <h3>Dr. Tim Clinton, President of the American Association of Christian Counselors</h3>
              <p>
                “Studies have proven that a comfortable environment and trust in the counselor are necessary for healing. By partnering with
                <a
                  href="javascript:void(0)"
                >TrueLifeCare.org</a>, your people are invited to anonymously access high-quality content from trusted leaders in the Christian counseling community.”
              </p>
            </div>
            <div class="work">
              <h2>How TLC Works</h2>
              <div class="tlc">
                <figure>
                  <img src="/images/img3.png" alt="img3" />
                </figure>
              </div>
              <div class="work_cnt">
                <p>When a church participates with TRUELIFECARE.org, their members are given access to videos and articles on popular counseling topics with leading Christian experts.</p>
                <p>Implementation is easy. The church’s unique username and password are displayed on bulletins and projectors, allowing partnering church members to anonymously view our helpful content whenever and wherever they want.</p>
              </div>
              <div class="shape">
                <figure>
                  <img src="/images/shape1.png" alt="shape1" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="library_main">
        <div class="container">
          <div class="library">
            <h2>
              Member Accessible Video
              <br />Library
            </h2>
          </div>
        </div>
        <div class="library_in">
          <div class="present">
            <div class="grief">
              <ul :class="`d-flex flex-wrap slick1 ${isDesktop?'':'mobile'}`">
                <li
                  class="col-md-4"
                  v-for="video in getVideos"
                  :key="video.slug"
                  v-html="video.player"
                ></li>
              </ul>
              <div class="clearfix" />
            </div>
            <div class="library_cnt">
              <p>
                We give your church a specific username and login to view our vast video christian counseling library on
                <br />situational, emotional, and psychological issues.
              </p>
              <div class="counsel">
                <span class="tlc_anchor">
                  <img src="/images/img5.png" alt="img5" />
                </span>
                <ul>
                  <li>
                    <router-link
                      :to="{ name: 'videoLibrary' }"
                      v-text="'VIEW OUR COMPLETE VIDEO LIBRARY'"
                    />
                  </li>
                  <li class="meet">
                    <router-link
                      :to="{ name: 'speakerBios' }"
                      v-text="'MEET OUR WORLD RENOWNED COUNSELORS'"
                      class="active"
                    />
                  </li>
                </ul>
                <div class="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="features_main">
        <div class="container">
          <div class="features">
            <div class="features_hd">
              <h2>Our Features</h2>
              <p>
                When a church participates with TRUELIFECARE.org, their members are given access to videos and articles on popular
                <br />counseling topics with leading Christian experts.
              </p>
            </div>
            <div class="healing">
              <div class="healing_in">
                <a href="javascript:void(0)">
                  <img src="/images/img9.png" alt="img9" />
                </a>
                <div class="cares">
                  <div class="care_in care_in1">
                    <h3>Preventative Care</h3>
                    <p>
                      Avert a crisis by giving your whole church anonymous access
                      <br />to a robust catalog of reliable Christian counseling content.
                    </p>
                  </div>
                </div>
                <div class="cares cares1">
                  <div class="care_in care_in1">
                    <h3>Counseling Reference Center</h3>
                    <p>
                      Prepare for your counseling sessions using our online reference library
                      <br />of relevant videos and articles.
                    </p>
                  </div>
                </div>
                <div class="cares cares2">
                  <div class="care_in care_in1">
                    <h3>Time Saving</h3>
                    <p>
                      To maximize pastoral counseling, use our online
                      <br />video content for initial counseling sessions and counseling homework.
                    </p>
                  </div>
                </div>

                <div class="expets">
                  <div class="care_in">
                    <h3>Relevant Counseling Topics</h3>
                    <p>
                      Dynamic Christ-centered clinically
                      <br />sound teaching
                    </p>
                  </div>
                </div>
                <div class="expets expets1">
                  <div class="care_in">
                    <h3>Today’s Leading Experts</h3>
                    <p>
                      The online videos feature leading Chris
                      <br />tian counselors
                    </p>
                  </div>
                </div>
                <div class="expets expets2">
                  <div class="care_in">
                    <h3>One Simple Tool</h3>
                    <p>
                      TrueLifeCare.org is available 24/7 on any com
                      <br />puter, smart phone or tablet
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about_main">
        <div class="container">
          <div class="about">
            <div class="about_hd">
              <h2>What They're Saying About TLC</h2>
            </div>
            <div class="testimonial">
              <div class="testimonial_in slick">
                <div class="test_list">
                  <div class="test_cnt">
                    <figure>
                      <img src="/images/img2.png" alt="img2" />
                    </figure>
                    <h3>Dr. Tim Clinton</h3>
                    <span>American Association of Christian Counselors, President</span>
                    <p>“Studies have proven that a comfortable environment and trust in the counselor are necessary for healing. By partnering with TrueLifeCare.org, your people are invited to anonymously access high-quality content from trusted leaders in the Christian counseling community.”</p>
                  </div>
                </div>
                <div class="test_list">
                  <div class="test_cnt">
                    <figure>
                      <img src="/images/img11.png" alt="img11" />
                    </figure>
                    <h3>Jonathan Falwell</h3>
                    <span>Pastor of Thomas Road Baptist Church</span>
                    <p>“Many people want to change the world but are held back by their own personal problems. Your partnership with TrueLifeCare.org allows your church members to find freedom and healing through an easily accessible website.”</p>
                  </div>
                </div>
                <div class="test_list">
                  <div class="test_cnt">
                    <figure>
                      <img src="/images/img13.png" alt="img13" />
                    </figure>
                    <h3>Dr. Josh McDowell</h3>
                    <span>Josh McDowell Ministries, President</span>
                    <p>“Feeling embarrassed has prevented many Christians from going to counseling. TrueLifeCare.org allows your members to access information in a non-confrontational environment. Pastors, this is the counseling solution you have been praying for!”</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade video-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img
          class
          src="https://www.truelifecare.org/wp-content/uploads/cp_modal/modal_home_page_vimeo_cp_id_3ecf6/cross.png"
          alt="close-link"
        />
      </button>
      <div class="modal-dialog">
        <div class="modal-content">
          <div style="padding:56.25% 0 0 0;position:relative;">
            <iframe
              src="https://player.vimeo.com/video/275753253?autoplay=0&color=126912&title=0&byline=0&portrait=0"
              style="position:absolute;top:0;left:0;width:100%;height:100%;"
              frameborder="0"
              allow="fullscreen"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, take, includes } from 'lodash'
import { mapState } from 'vuex'
import deviceDetected from '@/utils/detect-device'
export default {
  name: 'Home',
  computed: {
    ...mapState({
      videos: 'videos',
      user: 'user'
    }),
    getVideos() {
      return [
        {slug: '284426430', player: '<iframe src="https://player.vimeo.com/video/284426430" width="100%" height="360" frameborder="0" scrolling="auto" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'},
        {slug: '284855711', player: '<iframe src="https://player.vimeo.com/video/284855711" width="100%" height="360" frameborder="0" scrolling="auto" allowfullscreen=""></iframe>'},
        {slug: '284426955', player: '<iframe src="https://player.vimeo.com/video/284426955" width="100%" height="360" frameborder="0" scrolling="auto" allowfullscreen=""></iframe>'},
        {slug: '284428611', player: '<iframe src="https://player.vimeo.com/video/284428611" width="100%" height="360" frameborder="0" scrolling="auto" allowfullscreen=""></iframe>'},
        {slug: '284833805', player: '<iframe src="https://player.vimeo.com/video/284833805" width="100%" height="360" frameborder="0" scrolling="auto" allowfullscreen=""></iframe>'},
        {slug: '284429470', player: '<iframe src="https://player.vimeo.com/video/284429470" width="100%" height="360" frameborder="0" scrolling="auto" allowfullscreen=""></iframe>'},
      ]
    },
    isDesktop() {
      return !deviceDetected.isMobileOrTablet()
    }
  },

  mounted() {
    this.$nextTick(() => {
      // this.$store.dispatch('hideLoader')
      $('.slick1').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: this.isDesktop ? 3 : 1,
        slidesToScroll: this.isDesktop ? 3 : 1
      })
      $('.slick').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      })
    })
  },
  methods: {
    async handleSubmit(e) {
      const email = $('#loginUserName').val()
      const password = $('#loginPassword').val()
      if (email && password) {
        await this.$store.dispatch('login', [email, password])

        if (includes(this.user.role, 'care')) {
          this.$router.push({ name: 'videoLibrary' })
        }
        if (includes(this.user.role, 'individual')) {
          this.$router.push({ name: 'myChurchProfile' })
        }
      }
    }
  }
}
</script>
<style lang="scss">
.slick1 {
  &:hover {
    .slick-prev,
    .slick-next {
      display: block !important;
      z-index: 99;
    }
    .slick-prev {
      left: 0;
    }
    .slick-next {
      right: 30px;
    }
  }
  &.mobile {
    .slick-prev,
    .slick-next {
      display: block !important;
      z-index: 99;
    }
  }
  .slick-prev,
  .slick-next {
    display: none !important;
    &::before {
      color: #ffffff;
      font-size: 50px;
      padding-top: 40px;
      padding-right: 10px;
      padding-bottom: 40px;
      padding-left: 10px;
      background: rgba(51, 51, 51, 0.58);
    }
    &:hover::before {
      color: #f2e160;
    }
  }
  .slick-prev {
    left: 0;
  }
  .slick-next {
    right: 30px;
  }
}
.video-modal {
  .modal-dialog {
    max-width: 1000px;
    margin-top: 100px;
    padding: 10px;
  }
  button.close {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 32px;
    opacity: 1;
  }
}
</style>
